










import { Component, Vue } from "vue-property-decorator";
import ChampTable  from "@/components/ChampTable.vue"; 

@Component({
  components: {
    ChampTable
  }
})
export default class Home extends Vue {}
